import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { findPayrollStartAndEndDates } from '../helpers/payroll';
import { updateCurrentTimeEntriesRange } from './state/timecards.actions';
import useDivisionUsers from '../common/hooks/useDivisionUsers';
import useLoadTimeEntries from '../common/hooks/useLoadTimeEntries';

function DivisionTimeEntriesGetter() {
  const dispatch = useDispatch();

  const firstPayrollDay = useSelector((state) => state.timecards.firstPayrollDay);
  const payPeriod = useSelector((state) => state.timecards.payPeriod);
  const semiMonthlyPayPeriodDates = useSelector((state) => (
    state.timecards.semiMonthlyPayPeriodDates
  ));
  const divisionUsers = useDivisionUsers();
  const userIds = useMemo(() => divisionUsers.map((u) => u.id), [divisionUsers]);

  const [
    payPeriodStart,
    payPeriodEnd,
  ] = useMemo(() => (
    findPayrollStartAndEndDates({
      payPeriodFirstDay: firstPayrollDay,
      payPeriod,
      semiMonthlyPayPeriodDates,
    })
  ), [firstPayrollDay, payPeriod, semiMonthlyPayPeriodDates]);

  useLoadTimeEntries({
    userIds,
    startDate: payPeriodStart.toISODate(),
    endDate: payPeriodEnd.toISODate(),
    getCardDetails: true,
    onLoaded: () => dispatch(updateCurrentTimeEntriesRange(payPeriodStart, payPeriodEnd)),
  });

  return null;
}

export default DivisionTimeEntriesGetter;
